import { render, staticRenderFns } from "./OperatorsStatus.vue?vue&type=template&id=49f3d0f9&scoped=true&class=operators-status&"
import script from "./OperatorsStatus.vue?vue&type=script&lang=js&"
export * from "./OperatorsStatus.vue?vue&type=script&lang=js&"
import style0 from "./OperatorsStatus.vue?vue&type=style&index=0&id=49f3d0f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f3d0f9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
installComponents(component, {VCard,VCardActions,VCardText,VDataTable,VDialog})
